let m_opt = {
  EN : [
    { value: '*', text: 'every min' },
    { value: '*/5', text: '5 min interval'},
    { value: '*/10', text: '10 min interval'},
    { value: '*/15', text: '15 min interval'},
    { value: '*/20', text: '20 min interval'},
    { value: '*/30', text: '30 min interval'},
    { value: '*/45', text: '45 min interval'}
  ],
  KO : [
    { value: '*', text: '매분' },
    { value: '*/5', text: '5 분 마다'},
    { value: '*/10', text: '10 분 마다'},
    { value: '*/15', text: '15 분 마다'},
    { value: '*/20', text: '20 분 마다'},
    { value: '*/30', text: '30 분 마다'},
    { value: '*/45', text: '45 분 마다'}
  ],
  JP : [
    { value: '*', text: '毎分' },
    { value: '*/5', text: '5分間隔'},
    { value: '*/10', text: '10分間隔'},
    { value: '*/15', text: '15分間隔'},
    { value: '*/20', text: '20分間隔'},
    { value: '*/30', text: '30分間隔'},
    { value: '*/45', text: '45分間隔'}
  ]
}

let h_opt = {
  EN : [
    { value: '*', text: 'every hour' },
    { value: '*/2', text: '2 hour interval'},
    { value: '*/3', text: '3 hour interval'},
    { value: '*/4', text: '4 hour interval'}
  ],
  KO : [
    { value: '*', text: '매시간' },
    { value: '*/2', text: '2 시간마다'},
    { value: '*/3', text: '3 시간마다'},
    { value: '*/4', text: '4 시간마다'}
  ],
  JP : [
    { value: '*', text: '毎時' },
    { value: '*/2', text: '2時間間隔'},
    { value: '*/3', text: '3時間間隔'},
    { value: '*/4', text: '4時間間隔'}
  ]
};

import { api } from '@/f1/service';
import moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
const default_moment = extendMoment(require('moment'));

import Custom from '@/f1/service/custom';
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';

// 위에 사용 안하는 것 확인 필요
import vSelect from 'vue-select';
import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
import _ from 'lodash'

import StepProgress from 'vue-step-progress';

// 도메인별 보고서 준비
import Multiselect from 'vue-multiselect'
import ruleI18n from '../WebCastle/log/rule.i18n' // 정책 번영 파일 추가

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: {
    Multiselect,
    StepProgress,
    // util
    hexToRgba,
    VueHotelDatepicker,
    vSelect,
  },
  data: () => {
    return {
      ruleI18n,
      index_title : 0,
      index_title_list : [],
      SUMMARY : { group : '', service_name : '', prev_subscription : [] },
      domain_loading : false,
      webcastle : {
        use : 0,
        summary_1_4 : [],
        agent_list : [],
        agent_daily_stats : [],
        domain_severity_stats : [],
      },
      agent_list : [],
      agent : [],
      domain_list : [],
      domain : [],

      custom : Custom.custom_default,
      is_wmds : true,
      is_wsf : true,
      is_wc : true,
      is_wf : true,

      start_wc : 1,
      start_wsf : 1,
      start_wmds : 1,
      start_wf : 1,

      loading : false,
      codes,
      auth,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      is_report_custom : false, // 보고서 기간 선택
      blank_chart_data : [],
      opt : {
        month : '',
        year : ''
      },
      start_year : '2019', // uwss 시작년
      max : 90,
      start : 1,
      from : '2020-01-01',
      to : '2020-02-01',
      formData: [],
      minDate: "2000-01-01",
      maxDate: moment(new Date()).format('YYYY-MM-DD'),
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
    years() {
      let year_list = []
      for (let y = this.start_year; y <= new Date().getFullYear(); y++) { year_list.push(y) }
      return year_list.reverse()
    }
  },
  methods: {
    async report(custom_start = '', custom_end = ''){
      if(custom_start) { this.from = moment(custom_start).format('YYYY-MM-DD') }
      if(custom_end) { this.to = moment(custom_end).format('YYYY-MM-DD') }

      let start
      let end
      let range = []

      if(this.is_report_custom) {
        start = custom_start ? moment(custom_start).format('YYYY-MM-DD') : default_moment(this.from, 'YYYY-MM-DD').format('YYYY-MM-DD')
        end = custom_end ? moment(custom_end).format('YYYY-MM-DD') : default_moment(this.to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        console.log('is custom', 'start', start, 'end', end, range.length)
      } else {
        if(!this.opt.month || !this.opt.year) {
          this.loading = false
          return this.$toastr.w(`${i18n_toastr._i18n_msg.choice_date[this.i18n]}`)
        }

        this.opt.year = this.opt.year ? this.opt.year : new Date().getFullYear()

        let month = this.opt.month && this.opt.month.value ? this.opt.month.value : new Date().getMonth()
        month = month.toString().padStart(2, '0')
        let day = new Date(this.opt.year, month, 0).getDate().toString()
        day = day.padStart(2, '0')
        start = `${this.opt.year}-${month}-01`
        end = `${this.opt.year}-${month}-${day}`
        console.log('is monthly', 'start', start, 'end', end)
      }

      this.from = start
      this.to = end
    },
    async makePDF(){
      if(this.download) { this.$toastr.w(`${i18n_toastr._i18n_warning.download[this.i18n]}`); return; }
      this.loading = true;
      this.report();
      await api.util.PDF({
        company: document.getElementById('doc_report_short_title').innerHTML,
        language: localStorage.UWSS_LANG,
        solution: {
          is_webcastle: this.is_wc,
          is_wsfinder: this.is_wsf,
          is_wmds: this.is_wmds,
          is_wfdetector: this.is_wf
        },
        startDate: default_moment(this.from, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        endDate: default_moment(this.to, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        wc_agent_list: _.map(this.agent, x => x.agent_id),
        wc_domain_list: this.domain 
      }).then(rs => {
        this.download = true;
        let blob = new Blob([rs], { type: 'application/pdf' });
        let fileName = `${this.custom.slogan || 'F1-UWSS'} Report (${this.from}-${this.to}).pdf`;
        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else { // not IE
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.target = '_self'
          if (fileName) link.download = fileName
          link.click()
        }

        this.$toastr.s(`${i18n_data._i18n_success.service_cancel[this.i18n]}`)
        this.status = Object.assign({}, this.status, { processing : false })
      }).catch(e => { console.log("error: ", e.data); this.loading = false; this.$toastr.e(`${i18n_toastr._i18n_error.makePDF[this.i18n]}`); } )
      this.download = false;
      this.loading = false;
    },
    is_f1security_slogan() {
      return this.custom && this.custom.slogan && this.custom.slogan.toLowerCase().indexOf('f1-uwss') > -1
    },
    add_tag (newTag) { this.agent_list.push(newTag) && this.agent.push(newTag.agent_id) },
    confirm_custom(date) { this.report(date.start, date.end) },
    getAgentList: function() {
      api.webcastle.WebCastle({ target : 'agent', cmd : 'list.info' }).then(rs => {
        this.agent_list = []
        rs.body ? rs.body.forEach(agent => this.agent_list.push(agent)) : ''
      }).catch(error => {
        console.error(error)
      })
    },
    getDomainList: function() {
      this.domain_loading = true
      console.log('search', this.agent.length, _.map(this.agent, x => x.agent_id))
      api.webcastle.WebCastle({ target : 'agent', cmd : 'list.domain', body : { from : this.from, to : this.to, agent_list : _.map(this.agent, x => x.agent_id) } }).then(rs => {
        this.domain_list = []
        rs.body ? rs.body.forEach(domain => this.domain_list.push(domain)) : ''
        console.log('loaded domain', rs.body.length)
        this.domain_loading = false
      }).catch(error => {
        this.domain_loading = false
        console.log(error)
      })
    }
  },
  created: function() {
    this.from = moment(new Date()).format('YYYY-MM-DD');
    this.to = moment(new Date()).format('YYYY-MM-DD');
    this.opt.year = moment(this.from).format('YYYY')

    console.log(`[${this.custom.slogan}] Report.vue`, 'created');
  },
  destroyed: function() { console.log(`[${this.custom.slogan}] Report.vue`, 'destroyed'); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}] Report.vue`, 'mounted');
    console.log("report is", localStorage['UWSS_LANG'])

    // this.is_wsf = this.auth.license.WSFinder.use
    this.is_wc = this.auth.license.WEBCastle.use
    // this.is_wmds = this.auth.license.WMDS.use
    // this.is_wf = this.auth.license.WFDetect.use

    this.is_wsf = false;
    this.is_wmds = false;
    this.is_wf = false;

    // 현재는 영어만 사용
    for(let i = 0; i < 60; i++) {
      m_opt['EN'].push({ value: i.toString(), text: i +  ` ${i18n_toastr._i18n_msg.min['EN']}` });
      m_opt['KO'].push({ value: i.toString(), text: i +  ` ${i18n_toastr._i18n_msg.min['KO']}` });
      m_opt['JP'].push({ value: i.toString(), text: i +  ` ${i18n_toastr._i18n_msg.min['JP']}` });
    }
    for(let i = 0; i < 24; i++) {
      h_opt['EN'].push({ value: i.toString(), text: i + ` ${i18n_toastr._i18n_msg.hour['EN']}` });
      h_opt['KO'].push({ value: i.toString(), text: i + ` ${i18n_toastr._i18n_msg.hour['KO']}` });
      h_opt['JP'].push({ value: i.toString(), text: i + ` ${i18n_toastr._i18n_msg.hour['JP']}` });
    }

    // 도메인별
    this.getAgentList()
    this.getDomainList()
  }
}
